export default "<ngx-ui-loader [loaderId]=\"id\"></ngx-ui-loader>"